import { track as vaTrack } from '@vercel/analytics';

export type AnalyticsEvent =
  | { type: 'page_view'; path: string }
  | { type: 'map_loaded'; startupCount: number; clusterCount: number }
  | { type: 'cluster_toggled'; clusterName: string; action: 'show' | 'hide' }
  | { type: 'all_clusters_shown' }
  | { type: 'all_clusters_hidden' }
  | { type: 'search_performed'; query: string; results: number }
  | { type: 'filter_applied'; filterType: string; filterValue: string }
  | { type: 'startup_clicked'; slug: string; name: string };

export const track = (event: AnalyticsEvent): void => {
  const { type, ...data } = event;
  vaTrack(type, data as Record<string, string | number | boolean | null>);
};
